import { TranslateService } from '@ngx-translate/core';
import { Notification, NotificationData } from './notification.model';

export class QuestionnaireNotification extends Notification {
  constructor(
    data: NotificationData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
    const haveResponse: boolean | string | null = data.questionnaire ? data.questionnaire.complete : this.readDate;
    this.description = this.translateService.instant('questionnaire_from_doctor', { doctor: data?.questionnaire?.doctor });
    this.actionName = !!haveResponse ? this.translateService.instant('completed') : this.translateService.instant('to_complete');
    this.actionRequired = !this.readDate;
  }
}
